<template>
    <main-panel v-if=" $route.params.path==null"
        class="info-of-patient">
        <template v-slot:header>
            <h2>{{$route.name}}</h2>
        </template>
        <div class="info-of-patient">
            <component 
                v-for = "item in skeleton" 
                :key="item" 
                :admin="admin"
                :is="item.component_name"
                :type-tols="item.component_name"
                :params="item.params"
                :header="item.header"
                :url="item.url"/> 
  
        </div>
    </main-panel>
    <component :is="$route.params.path"/>
</template>
<script>
import mainPanel from '../components/main/mainPanel.vue'
import { defineAsyncComponent } from 'vue';
import components from '@/mixins/components.mixin.js';
import axios from 'axios';
export default{
    mixins:[components],
    components:{
        mainPanel,
        accessible: defineAsyncComponent(() =>
            import('../components/infoOfPatient/accessibleMs.vue')
        ),
        questions: defineAsyncComponent(() =>
            import('../components/infoOfPatient/questionsMs.vue')
        ),
        insurance: defineAsyncComponent(() =>
            import('../components/infoOfPatient/insuranceMs.vue')
        ),      
        grade: defineAsyncComponent(() =>
            import('../components/infoOfPatient/gradeMs.vue')
        ),
        services: defineAsyncComponent(() =>
            import('../components/infoOfPatient/servicesMs.vue')
        )
    },
    mounted(){
        this.getSkeleton(this.$route.fullPath.substring(1))
        axios
            .get("https://mosp51.ru/api/login")
            .then(response=>{
                 console.log( response.data,'username')
                if (response.data.username){
                    this.admin = true
                } else {
                    this.admin = false
                }
            })
    },
    methods:{
    },
    data(){
        return{
            admin:false,
            offices:[],
            rights:"",
            responsibilities:"",
        }
    }
}
</script>
<style>
    .info-of-patient .offices__panel{
        display: grid;
        grid-template-columns:repeat(2,1fr); 
        gap: 32px;  
    }
    .info-of-patient .offices__panel .panel{
        width: 100%;
        padding: 32px;
    }

   .info-of-patient section:last-child{
        margin-bottom: 100px;
    }

</style>